import React, { useMemo } from 'react';
import { BaseNav } from './base-nav.component';
import { useNav } from '../../nav.context';

export const TasksNav = () => {
  const nav = useNav();
  const navLinks = useMemo(() => {
    return [
      { label: 'Tasks List', url: 'tasks/dashboard', enabled: nav.user.permissions.task_dashboard},
      { label: 'Engagements', url: 'engagements/dashboard', enabled: nav.user.permissions.tasks_engagements },
      { label: 'Tax Organizers', url: 'tax-prep-tasks/dashboard', enabled: nav.user.permissions.tasks_organizers},
    ];
  }, [nav.user]);

  return <BaseNav title="Tasks" nav={nav} navLinks={navLinks} />;
};
